import { useCallback, useLayoutEffect, useRef } from "react"

const useFrame = () => {
  const containerRef = useRef<HTMLDivElement>(null)

  const sendHeight = useCallback(() => {
    requestAnimationFrame(() => {
      const height = document.documentElement.scrollHeight
      window.parent.postMessage({ height }, "*")
    })
  }, [])

  useLayoutEffect(() => {
    const handleLoad = () => {
      sendHeight()
    }

    window.addEventListener("load", handleLoad)
    window.addEventListener("resize", sendHeight)

    // const observer = new MutationObserver(() => {
    const observer = new MutationObserver(() => {
      // Use a microtask to ensure all mutations are processed before sending the height
      Promise.resolve().then(() => {
        sendHeight()
      })
    })

    if (containerRef.current) {
      observer.observe(containerRef.current, {
        childList: true,
        subtree: true,
      })
    }

    // Send height after initial render
    sendHeight()

    return () => {
      window.removeEventListener("load", handleLoad)
      window.removeEventListener("resize", sendHeight)
      observer.disconnect()
    }
  }, [sendHeight])

  return { containerRef, sendHeight }
}

export default useFrame
